<template>
  <div>

    <table class="table table-hover">
      <thead>
      <tr>
        <th></th>
        <th>Naam</th>
        <th>Datum</th>
        <th>Actief</th>
        <th>Toekomst</th>
        <th>Afgerond</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(fase, index) in fases">
        <td>
          <i class="icon-arrow-up mr-2 hoverable" @click="moveUp(fase.id)" v-if="index!==0"></i>
          <i class="icon-arrow-down hoverable" @click="moveDown(fase.id)" v-if="(fases.length-1) !== index"></i>
        </td>
        <td>{{fase.name}}</td>
        <td><b-form-input type="date" v-model="fase.date" disabled size="sm"/></td>
        <td><b-form-checkbox switch v-model="fase.active" disabled value=1 unchecked-value=0></b-form-checkbox></td>
        <td><b-form-checkbox switch v-model="fase.future" disabled value=1 unchecked-value=0></b-form-checkbox></td>
        <td><b-form-checkbox switch v-model="fase.completed" disabled value=1 unchecked-value=0></b-form-checkbox></td>
        <td>
          <b-button variant="primary" size="sm" class="mr-1" @click="editFase(fase.id)">Bewerk</b-button>
          <b-button variant="danger" size="sm" @click="deleteItem(fase.id, fase.name)">Verwijder</b-button>
        </td>
      </tr>
      </tbody>
    </table>
    <hr>
    <p><em>De projectfases worden in de portal aangemaakt gebaseerd op een standard set. Afhankelijk van het type project is er een set met fases. Soms worden de fases niet aangemaakt of is er behoefte om de fases opnieuw te genereren (omdat er bijvoorbeeld per ongeluk 1 verwijderd is). Dat is hieronder mogelijk. Maar let op; alle huidige fases verdwijnen en worden vervangen door de standard set.</em></p>
    <b-button size="sm" @click="regenerateProjectFases">Regenereer standaard project fases</b-button>
    <b-modal ref="edit-modal" title="Bewerk fase" hide-footer>
      <form @submit.prevent="updateItem">
        <b-form-group
          label="Naam"
          label-for="name"
          invalid-feedback="Naam is een verplicht veld"
        >
          <b-form-input
            id="name"
            v-model="item.name"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Datum"
          label-for="date"
          invalid-feedback="Datum is een verplicht veld"
        >
          <b-form-input
            id="name"
            type="date"
            v-model="item.date"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Actief"
          label-for="active"
        >
          <b-form-checkbox
            switch
            id="active"
            v-model="item.active"
            value=1
            unchecked-value=0
          ></b-form-checkbox>
        </b-form-group>
        <b-form-group
          label="Toekomst"
          label-for="future"
        >
          <b-form-checkbox
            switch
            id="future"
            v-model="item.future"
            value=1
            unchecked-value=0
          ></b-form-checkbox>
        </b-form-group>
        <b-form-group
          label="Afgerond"
          label-for="completed"
        >
          <b-form-checkbox
            switch
            id="completed"
            v-model="item.completed"
            value=1
            unchecked-value=0
          ></b-form-checkbox>
        </b-form-group>
        <b-button type="submit">Opslaan</b-button>
      </form>
    </b-modal>
  </div>
</template>
<script>
import {deleteItem, getData, updateData, addData} from "@/api";

export default {
  name: 'project-fases',
  props: ['fases', 'projectId'],
  data: function() {
    return {
      item: {}
    }
  },
  methods: {
    async refreshData() {
      const item = await getData('projects/' + this.projectId).then(response => response.data);
      this.fases = item.data.fases;
    },
    editFase(id) {
      this.getItem(id);
      this.$refs['edit-modal'].show()
    },
    async getItem(id) {
      const item = await getData('project-fases/' + id).then(response => response.data);
      this.item = item.data
    },
    async moveUp(id) {
      await getData('project-fases/' + id + '/move-up').then(response => response.data);
      this.refreshData();
    },
    async moveDown(id) {
      await getData('project-fases/' + id + '/move-down').then(response => response.data);
      this.refreshData();
    },
    async updateItem() {
      await updateData('project-fases/' + this.item.id, this.item)
      this.refreshData();
      this.$refs['edit-modal'].hide()
    },
    async deleteItem(id, name) {
      if(confirm("Wil je de fase '"+name+"' echt verwijderen?")) {
        await deleteItem('project-fases/' + id).then();
      }
      this.refreshData();
    },
    async regenerateProjectFases() {
      if(confirm("Weet je zeker dat je de fases opnieuw wilt genereren? Alle huidige fases worden vervangen.")) {
        await addData(`projects/${this.projectId}/regenerate-fases`).then(response => response.data);
        this.refreshData();
      }
    }
  }
}
</script>
